import { useQuery } from '@tanstack/react-query'
import type { ResponseApiError } from '../../models/axios-error'
import axios, { type AxiosRequestConfig, type AxiosResponse } from 'axios'
import type { UseQueryOptionsWithoutQueryKey } from '../../react-query-config'
import type { AggregationLevel, Channel } from './home.model'

export interface UseApiGetGmvEvaluation {
  channel: Channel
  aggregation: AggregationLevel
  storeId: number
  teamId: number | null
}

export interface GmvEvaluation {
  yearToDateEvaluation: string | null
  yearEvaluation: string | null
  forecastTrajectoryGap: number | null
}

const getGmvEvaluation = async (config: AxiosRequestConfig, enabled: boolean): Promise<GmvEvaluation> => {
  if (!enabled) {
    return {
      yearToDateEvaluation: undefined,
      yearEvaluation: undefined,
      forecastTrajectoryGap: undefined
    }
  }
  const axiosPromise: AxiosResponse<GmvEvaluation> = await axios(config)
  return {
    yearToDateEvaluation: axiosPromise.data?.yearToDateEvaluation,
    yearEvaluation: axiosPromise.data?.yearEvaluation,
    forecastTrajectoryGap: axiosPromise.data?.forecastTrajectoryGap
  }
}

export const useApiGetGmvEvaluation = (
  request: UseApiGetGmvEvaluation,
  enabled: boolean,
  options?: UseQueryOptionsWithoutQueryKey<GmvEvaluation>
) => {
  const { storeId, teamId, channel, aggregation } = request
  const teamParam = aggregation === 'TEAM' && teamId !== null ? `&teamId=${teamId}` : ''
  const url = `/v2/cumulative-gross-merchandise-value-evaluation?aggregation=${aggregation}&channel=${channel}&storeId=${storeId}${teamParam}`
  const config: AxiosRequestConfig = { method: 'get', url }

  return useQuery<GmvEvaluation, ResponseApiError>({
    queryKey: ['get-target-productivity', url],
    queryFn: () => getGmvEvaluation(config, enabled),
    enabled,
    ...options
  })
}
